<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 scrollTableNoTab">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @change-selected="changeSelectedTable"
                            @get-column-settings="getColumnSettings"
                            ref="gofixTable">
                            <template slot="gofix_table:after-control-left">
                                <gofix-button class="ml-2" label="Proceed" outline @click="proceedApproval"></gofix-button>
                            </template>
                            <template slot="gofix_table:actions" slot-scope="data" v-if="data.item.status === 'Posted'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:pv_date" slot-scope="row">
                                {{row.item.pv_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:payment_amount" slot-scope="row">
                                {{ row.item.payment_amount | formatMoney }}
                            </template>
                            <template slot="gofix_table:gst" slot-scope="row">
                                {{ row.item.gst | formatMoney }}
                            </template>
                            <template slot="gofix_table:total" slot-scope="row">
                                {{ row.item.total | formatMoney }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
        <ApprovalMultiple 
            title="Approval For Multiple Payments" 
            :payments="proceed.ids" v-model="proceed.open"
            @approval-success="$refs.gofixTable.reloadTableKeepFilter()" />
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    const ApprovalMultiple = () => import('@/views/dashboard-approval/approval-multiple')

    export default {
        name: 'payment-voucher',
        components: {
            ApprovalMultiple
        },
        props: {
            platform: {
                type: String,
                default: ''
            },
            nameTable: {
                type: String,
                default: ''
            }
        },
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['payment_voucher_approval']));
            return {
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    isCMS: true,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems: [],
                proceed: {
                    open: false,
                    ids:  []
                }
            }
        },
        watch: {
            // platform: function(val) {
            //     this.$refs.gofixTable.reloadTableKeepFilter();
            // }
        },
        created(){
        },
        methods:{
            getColumnSettings(settings){
                // if(settings.length && this.$refs.gofixTable) {
                //     let field = settings.map(item => {
                //         if(item.key == "status") {
                //             item.isFilter = false;
                //             item.filter.active = false;
                //         }
                //         return item;
                //     });
                //     this.$refs.gofixTable.updateColumnSettings(field);
                // }
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.type_check = this.platform;
                await this.$store.dispatch("AwaitingApprovalController/getAwaitingApproval", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                return this.$router.push(`/approvals/${this.platform == 'pv_fm' ? 'fm' : 'lm'}-payment-vouchers/${item.id}`)
            },
            changeSelectedTable(ids) {
                this.proceed.ids = ids;
            },
            proceedApproval() {
                if(!this.proceed.ids.length)
                    return this.$alertNotification('Please select at least one item before proceed', 'danger');
                this.proceed.open = true;
            }
        }
    }
</script>
